import { getCsrfToken } from '../auth/authApi'
import type { ProductionOrdersSnapshot } from './types'
import { apiFetch } from '../../shared/http/apiFetch'
const baseUrl='/api/v1/production-orders'
export async function getProductionOrders(options?:Record<string,string|number|undefined>):Promise<ProductionOrdersSnapshot>{
  const parameters=new URLSearchParams()
  if(options)Object.entries(options).forEach(([key,value])=>{if(value!==undefined&&value!=='')parameters.set(key,String(value))})
  const response=await apiFetch(`${baseUrl}${parameters.size?`?${parameters}`:''}`,{credentials:'include'})
  if(!response.ok){const payload=await response.json().catch(()=>null) as {code?:string}|null;throw new Error(payload?.code??'orders.loadError')}
  return response.json() as Promise<ProductionOrdersSnapshot>
}
export async function getProductionOrder(id:string,signal?:AbortSignal):Promise<ProductionOrdersSnapshot>{
  const response=await apiFetch(`${baseUrl}/${encodeURIComponent(id)}`,{credentials:'include',signal})
  if(!response.ok){const payload=await response.json().catch(()=>null) as {code?:string}|null;throw new Error(payload?.code??(response.status===404?'orders.notFound':'orders.loadError'))}
  return response.json() as Promise<ProductionOrdersSnapshot>
}
export async function orderCommand(path:string,method:'POST'|'PUT',body:unknown){
  const response=await apiFetch(`${baseUrl}${path}`,{method,credentials:'include',headers:{
    'Content-Type':'application/json','X-CSRF-TOKEN':await getCsrfToken(),
  },body:JSON.stringify(body)})
  const payload=await response.json().catch(()=>null) as {code?:string;planningScenarioRequired?:boolean}|null
  if(!response.ok)throw new Error(payload?.code??'orders.actionError')
  return{code:payload?.code??'orders.saved',planningScenarioRequired:payload?.planningScenarioRequired??false}
}
